import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "16",
      cy: "16",
      r: "15.6",
      fill: "#fff",
      stroke: "#CBCBCB",
      "stroke-width": ".8",
      class: "st2"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-linecap": "round",
      "stroke-width": ".8",
      d: "M13 11.5c0-1.7 1.3-3.1 3-3.1s3 1.4 3 3.1-.2 1.2-.5 1.7c-.9 1.4-2.5 2.8-2.5 4.5v.8",
      class: "st1"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-linecap": "round",
      "stroke-width": "1.4",
      d: "M16 22.4h0",
      class: "st0"
    }, null, -1)
  ]))]))
}
export default { render: render }